<script setup lang="ts">
import { computed } from 'vue'
import { ErrorCircle16Regular, CheckmarkCircle16Regular, ArrowSyncCircle16Regular } from '@vicons/fluent'

const props = defineProps<{
  state: string
}>()

const type = computed(() => {
  switch (props.state) {
    case 'Completed':
      return 'success'
    case 'Failed':
      return 'error'
    case 'Pending':
      return 'info'
    default:
      return ''
  }
})
</script>

<template>
  <n-tag :type="type" :bordered="false">
    {{ state }}

    <template #icon>
      <n-icon v-if="state === 'Failed'">
        <ErrorCircle16Regular />
      </n-icon>
      <n-icon v-else-if="state === 'Completed'">
        <CheckmarkCircle16Regular />
      </n-icon>
      <n-icon v-else-if="state === 'Pending'">
        <ArrowSyncCircle16Regular />
      </n-icon>
    </template>
  </n-tag>
</template>